export const GET_PROCESS_TYPE = 'GET_PROCESS_TYPE';
export const PROCESS_TYPE_REQUEST = 'PROCESS_TYPE_REQUEST';
export const CREATE_PROCESS_TYPE = 'CREATE_PROCESS_TYPE';
export const UPDATE_PROCESS_TYPE = 'UPDATE_PROCESS_TYPE';
export const DELETE_PROCESS_TYPE = 'DELETE_PROCESS_TYPE';
export const PROCESS_TYPE_REQUEST_FAILURE = 'PROCESS_TYPE_REQUEST_FAILURE';
export const GET_PROCESS_TYPE_PAGE = 'GET_PROCESS_TYPE_PAGE';
export const PROCESS_TYPE_REQUEST_SUCCESS = 'PROCESS_TYPE_REQUEST_SUCCESS';